module.exports = __webpack_public_path__ + "static/assets/33eee938792ed941e5abb27d50895743.svg";